import { Configuration, PopupRequest, RedirectRequest, LogLevel } from '@azure/msal-browser';
import { AppConfig } from '@/config/runtime-config';

export function createMsalConfig(config: AppConfig): Configuration {
  return {
    auth: {
      clientId: config.azureClientId,
      authority: config.azureAuthority,
      redirectUri: config.redirectUri,
      postLogoutRedirectUri: config.postLogoutRedirectUri,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        logLevel: config.debugMode ? LogLevel.Verbose : LogLevel.Warning,
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) return;
          const logFn = [console.error, console.warn, console.info, console.debug][level];
          logFn?.(`[MSAL] ${message}`);
        },
        piiLoggingEnabled: false,
      },
    },
  };
}

export function createLoginRequest(config: AppConfig): RedirectRequest {
  return {
    scopes: ['openid', config.bolApiScope],
  };
}

export function createPopupRequest(config: AppConfig): PopupRequest {
  return {
    scopes: ['openid', config.bolApiScope],
  };
}
